import {
  applyTo,
  includes,
  partial,
  path,
  pathOr,
  pipe
} from "$json/lib/functional";
import { getControl } from "$json/lib/control";
import { conf } from "$json/lib/conf";
import { Ajax } from "$json/lib/ajax";
/* postcode-soap:
 *
 * Prefill street and city fields based on postcode (dutch). Assumes a
 * Webservice running on the same host at the path at api/soap/v1/postcode,
 * relative to document, accepting a soap request in the form returned by the
 * function soapBody().
 *
 * Fields are matched by their accompanying metadata:

 * Copyright (C) 2020 by Berkeley Bridge
 *
 */

(function ($, doc) {
  const url = pathOr("api/soap/v1/postcode", [
    "arbitrary",
    "postcode-soap-meta",
    "url"
  ]);
  const huisnummerRequired = pathOr(false, [
    "arbitrary",
    "postcode-soap-meta",
    "huisnummer-required"
  ]);

  const matchesInput = pipe(
    getControl,
    path(["metadata", "type"]),
    includes,
    applyTo(["postcode", "housenumber", "houseletter", "housenumberextra"])
  );

  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function soapBody(
    cijfers,
    letters,
    huisnummer,
    huisletter,
    huisnummertoevoeging
  ) {
    return `
      <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"
       xmlns:bb="www.berkeleybridge.nl/soap">
         <soap:Header/>
         <soap:Body>
            <bb:applymodel>
               <bb:modelname>postcode</bb:modelname>
               <bb:username>postcode</bb:username>
               <bb:password>nietgeheimhoor</bb:password>
               <bb:postcode>
                  <bb:cijfers>${cijfers}</bb:cijfers>
                  <bb:letters>${letters}</bb:letters>
                  <bb:huisnummer>${huisnummer}</bb:huisnummer>
                  <bb:huisletter>${huisletter}</bb:huisletter>
                  <bb:huisnummertoevoeging>${huisnummertoevoeging}</bb:huisnummertoevoeging>
               </bb:postcode>
            </bb:applymodel>
         </soap:Body>
      </soap:Envelope>
    `;
  }

  function mitigate(groupcontext, set, desired) {
    // Based on the group, set and type, return the correct element.
    let found = null;
    Array.from(groupcontext.querySelectorAll("input")).some(elt => {
      if (
        $(elt).data("control") &&
        $(elt).data("control").metadata &&
        $(elt).data("control").metadata.for &&
        $(elt).data("control").metadata.for === set &&
        $(elt).data("control").metadata.type === desired
      )
        found = elt;
    });
    return found;
  }

  $(function () {
    function fillData(
      cijfers,
      letters,
      huisnummer,
      huisletter,
      huisnummertoevoeging,
      groupcontext,
      set
    ) {
      Ajax.post({
        type: "post",
        url: url(conf),
        contentType: "text/xml; charset=utf-8",
        data: soapBody(
          cijfers,
          letters,
          huisnummer,
          huisletter,
          huisnummertoevoeging
        ),
        dataType: "xml",
        processData: false,
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "SOAPAction",
            "http://www.bridge-to-knowledge.nl/" + "postcode/postcode"
          );
        },

        success: function (msg) {
          var txt = msg;
          if (!txt) this.error.apply(this, arguments);
          else {
            var streetNode, street, citynameNode, cityname;
            // Non-IE
            if (typeof txt.getElementsByTagNameNS === "function") {
              street = txt.getElementsByTagNameNS(
                "www.berkeleybridge.nl/soap",
                "street"
              )[0].textContent;
              cityname = txt.getElementsByTagNameNS(
                "www.berkeleybridge.nl/soap",
                "cityname"
              )[0].textContent;
            } else {
              // IE
              msg.setProperty(
                "SelectionNamespaces",
                'xmlns:s="http://schemas.xmlsoap.org/soap/envelope/" ' +
                  'xmlns:bb="www.berkeleybridge.nl/soap"'
              );
              streetNode = msg.selectSingleNode(
                "s:Envelope/s:Body/bb:postcode-data-out/bb:street"
              );
              if (streetNode) street = streetNode.text;
              citynameNode = msg.selectSingleNode(
                "s:Envelope/s:Body/bb:postcode-data-out/bb:cityname"
              );
              if (citynameNode) cityname = citynameNode.text;
            }

            groupcontext.querySelectorAll("input").forEach(elt => {
              if (
                $(elt).data("control") &&
                $(elt).data("control").metadata &&
                $(elt).data("control").metadata.for &&
                $(elt).data("control").metadata.for === set
              ) {
                if ($(elt).data("control").metadata.type === "streetname") {
                  elt.value = street;
                } else if (
                  $(elt).data("control").metadata.type === "placename"
                ) {
                  elt.value = cityname;
                }
              }
            });
          }
        },
        error: function () {
          if (typeof console != "undefined" && console && console.log)
            console.log("error getting postcode", arguments);
        }
      });
    }

    $(doc).on("change", "input", e => {
      const target = e.target;
      try {
        if (matchesInput(target)) {
          let groupcontext = target.closest(".group, tr"),
            set = pipe(getControl, path(["metadata", "for"]))(target),
            mit = partial(mitigate, [groupcontext, set]),
            postcode = mit("postcode"),
            huisnummer = mit("housenumber"),
            huisletter = mit("houseletter"),
            huisnummertoevoeging = mit("housenumberextra");
          postcode = postcode ? postcode.value.trim() : false;
          huisnummer = huisnummer ? huisnummer.value.trim() : false;
          huisletter = huisletter ? huisletter.value.trim() : false;
          huisnummertoevoeging = huisnummertoevoeging
            ? huisnummertoevoeging.value.trim()
            : false;

          // Before we start, check we have both postcode & house number, if house number is in fact required.
          if (
            postcode.length &&
            (huisnummer.length || !huisnummerRequired(conf))
          ) {
            var matches = postcode.match(/^([0-9]{4})\s*([a-zA-Z]{2})$/);
            if (matches && matches.length == 3) {
              debounce(
                fillData(
                  matches[1],
                  matches[2],
                  huisnummer,
                  huisletter,
                  huisnummertoevoeging,
                  groupcontext,
                  set
                ),
                250
              );
            }
          }
        }
      } catch (err) {
        window.console && window.console.warn(err);
      }
    });
  });
})(jQuery, document);
